<nz-spin [nzSpinning]="loading || cooldown">
    <div *ngIf="error" class="error-container">
        <p>
            Error loading contexts.
            <a (click)="onReload()" class="reload-link">Retry</a>
        </p>
    </div>
    <div *ngIf="!error" class="am-dash-filter-footer-content">
        <div class="selector-container">
            <nz-select
                nzShowSearch
                nzAllowClear
                class="context-select"
                [ngModel]="selectedDashboardViewId"
                (ngModelChange)="onSelectSavedContext($event)"
                nzPlaceHolder="Load saved view"
                [nzLoading]="loading"
                nzSize="small"
                [nzDropdownMatchSelectWidth]="false"
            >
                <nz-option
                    *ngFor="let dashboardView of savedDashboardViews"
                    [nzValue]="dashboardView.id"
                    [nzLabel]="
                        dashboardView.name +
                        (dashboardView.isPublic ? '' : ' (Private)')
                    "
                >
                </nz-option>
            </nz-select>
            <div
                class="navigation-buttons"
                *ngIf="options.showNavigationButtons"
            >
                <button
                    nz-button
                    nzType="default"
                    (click)="onNext()"
                    [disabled]="
                        cooldown ||
                        !savedDashboardViews.length ||
                        savedDashboardViews[savedDashboardViews.length - 1]
                            .id === selectedDashboardViewId
                    "
                    nzSize="small"
                >
                    &lt;
                </button>
                <button
                    nz-button
                    nzType="default"
                    (click)="onPrevious()"
                    [disabled]="
                        cooldown ||
                        !savedDashboardViews.length ||
                        savedDashboardViews[0].id === selectedDashboardViewId
                    "
                    nzSize="small"
                >
                    &gt;
                </button>
            </div>
        </div>
    </div>
</nz-spin>
